import React, {FC} from "react"

import {CompanyNewsTile} from "@irati/types"

import CompanyNewsEditable from "./CompanyNewsEditable"
import CompanyNewsNonEditable from "./CompanyNewsNonEditable"
import {HomePageView} from "../types"

interface Props {
  companyNews: CompanyNewsTile[],
  id: string,
  isOnHover?: boolean,
  pageView: HomePageView,
  isAdmin: boolean,
  openModal?: boolean
}

const CompanyNews: FC<Props> = ({companyNews, id, isOnHover, pageView, isAdmin, openModal}) => {
  if (pageView === HomePageView.EMPLOYEE_VIEW || isAdmin) {
    return <CompanyNewsNonEditable isAdmin={isAdmin} id={id} companyNews={companyNews} pageView={pageView} />
  }

  return <CompanyNewsEditable id={id} companyNews={companyNews} pageView={pageView} isOnHover={isOnHover} openModal={openModal} />
}

export default CompanyNews
